import type { Space } from '@cocoonspace/sdk-js/types/space'
import { cn } from '@cocoonspace/ui/lib/utils'
import { TransportationLine } from '~/domains/spaces/components/atoms/transportation-line'
import { useSpaceStations } from '~/domains/spaces/hooks/use-space-stations.hook'

export const SpaceCardNearestStation = ({
	space,
	className,
}: {
	space: Space
	className?: string
}) => {
	const { stations } = useSpaceStations(space)
	const station = stations?.[0]
	const line = station?.lines?.[0]

	if (!line) return null

	return (
		<div
			className={cn(
				'flex flex-1 flex-row items-center justify-start gap-x-1 truncate',
				className,
			)}
		>
			<TransportationLine
				iconSize={16}
				line={line}
				space={space}
			/>

			<div className='flex-1 truncate text-xs'>{station.name}</div>
		</div>
	)
}
